import {
  USGA_POST_ACTIONS as SharedUsgaPostActions,
  USGA_POST_STATUSES as SharedUsgaPostStatuses,
  USGA_SCORE_TYPES as SharedUsgaScoreTypes,
} from "shared/dist/types/UsgaPost";

export type {
  UsgaPost,
  UsgaPostAction,
  UsgaPostBlock,
  UsgaPostLog,
  UsgaPostSent,
  UsgaPostStatus,
  UsgaScoreType,
} from "shared/dist/types/UsgaPost";

export const USGA_POST_ACTIONS = SharedUsgaPostActions;
export const USGA_POST_STATUSES = SharedUsgaPostStatuses;
export const USGA_SCORE_TYPES = SharedUsgaScoreTypes;
